<template>
	<!-- <div class="container-box"> -->
		<div :id="id" :style="{height:height,width:width}"></div>
	<!-- </div> -->
</template>

<script>
	import echarts from 'echarts';
	export default {
		props: ['className', 'id', 'height', 'width','labelData'],
		data() {
			return {}
		},
		mounted() {
			this.initData();
		},
		beforeDestroy() {

		},
		methods: {

			initData() {
				// 基于准备好的dom，初始化echarts实例
				let myChart = echarts.init(document.getElementById(this.id))
				// 绘制图表
				myChart.setOption({
					series: [{
							color:['#d38197','#cfc9a5','#55d1d8','red'],
							name: '区域用户类型',
							type: 'pie',
							radius: [20, 70],
							center: ['50%', '50%'],
							roseType: 'radius',
							label: {
								show: false
							},
							itemStyle:{
								// borderWidth:'20',
								// borderColor:'rgba(211, 129, 151, 0.5)'
								shadowColor: 'rgba(211, 129, 151, 0.5)',
								shadowBlur: 20
							},
							emphasis: {
								label: {
									show: false
								}
							},
							data: this.labelData
						}]
				})
			},

		}
	}
</script>

<style lang="less" scoped>
</style>
